import { TipoFormularioProposta } from "src/app/models/enum";

export class SumarioFormularioFinanciadoraModel {
  tipoFormulario: TipoFormularioProposta;
  idFormulario: number | null = null;
}
